import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
import arrowInCircle from '../../images/newDesign/arrow_in_white_circle.svg';
import PaymentFlowContainer from './PaymentFlowContainer';
import React, { useEffect, useMemo, useState } from 'react';
import ContentLoader from '../../common/simple/ContentLoader';
import { GAEvent } from '../../common/google_analytics/google_analytics';
import { NotificationManager } from 'react-notifications';
import { constants } from "../../common/constants/constants";
import { parsePhoneToInternational } from '../../common/utils/parseFunctions';
import { useSelector } from 'react-redux';
import ServerData from '../../common/serverData';
import CacheData from '../../common/utils/cacheData';

const ManagerDetails = ({ match }) => {
    const [contacts, setContacts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const client = new ServerData();
    const { t } = useTranslation();
    const currency = useSelector(state => state.tenant.buildingCurrency);
    const { buildingID } = match.params;

    useEffect(() => {
        setIsLoading(true);
        client.managers.contacts.getContactsByExternalBuildingId({
            buildingExternalId: buildingID,
            ownerType: 3
        })
            .then(setContacts)
            .catch(e => NotificationManager.error(e.message))
            .finally(() => setIsLoading(false))
    }, []);

    const contactsByContactType = useMemo(() => {
        const obj = {
            name: [],
            phone: [],
            email: [],
        }
        contacts.forEach(contact => {
           obj[contact.type].push(contact);
        });
        return obj;
    }, [contacts]);

    const onChatButtonClick = () => {
        const phone = contactsByContactType.phone[0]?.value;
        const parsedPhone = parsePhoneToInternational(currency, phone);

        if (parsedPhone) {
            GAEvent(constants.GoogleAnalytics.Events.managerOperations, 'sendViaPrivateWhatsApp', 1, 'sendViaPrivateWhatsAppLabel');
            window.open(`https://api.whatsapp.com/send?phone=${parsedPhone}&text=&source=&data=`);
        } else NotificationManager.error(t('reports.phone_is_unavailable'))
    }

    const renderNames = () => {
        if (contactsByContactType.name.length > 0) {
            return contactsByContactType.name.map(contact => {
                return (
                    <div key={contact.id} className='manager-value'>{contact.value}</div>
                )
            })
        } else {
            const cache = CacheData.fetchCache('buildingData', {buildingID: buildingID});
            const name = cache?.managementCompany?.name;
            if (name) {
                return (
                    <div className='manager-value'>{name}</div>
                )
            }
        }

    };
    const renderPhones = () => {
        return contactsByContactType.phone.map(contact => {
            return (
                <a href={`tel:${contact.value}`} key={contact.id} className='manager-value'>{contact.value}</a>
            )
        })
    };
    const renderEmails = () => {
        return contactsByContactType.email.map(contact => {
            return (
                <a href={`mailto:${contact.value}`} key={contact.id} className='manager-value'>{contact.value}</a>
            )
        })
    };

    const renderManagerDetails = () => {
        return (
            <>
                <div className='manager-details'>
                    <div>
                        <div className='details-header'>{t('payments.manager_name')}</div>                      
                        {renderNames()}
                    </div>

                    <div>
                        <div className='details-header'>{t('payments.manager_phone')}</div>                      
                        {renderPhones()}
                    </div>

                    <div>
                        <div className='details-header'>{t('payments.manager_email')}</div>                      
                        <div className='manager-value'>
                            {renderEmails()}
                        </div>
                    </div>
                </div>
                <Button onClick={onChatButtonClick}>
                    {t('payments.start_chat')} <img className='arrow' src={arrowInCircle}  alt="arrow"/>
                </Button>
            </>
        )
    }

    return (
        <PaymentFlowContainer title={t('payments.contact_manager')} subheader={t('payments.contact_manager_subheader')}>
            <div className='credit-card-and-actions-block managers'>
                {isLoading ? <ContentLoader width="100%" height={200} /> : renderManagerDetails()}
            </div>
        </PaymentFlowContainer>
    )
}

export default ManagerDetails;
